import "./Sidebar.css";
import { Link, useLocation } from "react-router-dom";
import { AiOutlineHome } from "react-icons/ai";
import { BsFillPersonFill } from "react-icons/bs";
import { RiMoneyEuroCircleFill } from "react-icons/ri";
import { HiLocationMarker } from "react-icons/hi";
import { FaSignOutAlt, FaShopify, FaQuestionCircle, FaTrophy, FaStore, FaBullhorn } from "react-icons/fa";

 import { AiOutlineCalendar } from "react-icons/ai";
import { signout } from "../apicalls/auth";
import { AiOutlineCalendar as AiOutlineCalendarAlt, AiOutlineClockCircle } from "react-icons/ai";

const Sidebar = ({ sidebarOpen, closeSidebar }) => {
  const location = useLocation();
  return (
    <div className={sidebarOpen ? "sidebar_responsive" : ""} id="sidebar">
      <div className="sidebar__title">
        <h2 className="text-center my-3">TheTennisPlan</h2>
        <i
          onClick={() => {
            closeSidebar();
          }}
          className="fa fa-times"
          id="sidebarIcon"
          aria-hidden="true"
        ></i>
      </div>

      <div className="sidebar__menu">
        <Link className="alink" to="/">
          <div
            className={
              location.pathname === "/"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <AiOutlineHome className="sidebar_icon" />
            Dashboard
          </div>
        </Link>
        <Link className="alink" to="/Coaches">
          <div
            className={
              location.pathname === "/Coaches"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <BsFillPersonFill className="sidebar_icon" />
            Coaches
          </div>
        </Link>

<Link className="alink" to="/coach-schedules">
  <div
    className={
      location.pathname === "/coach-schedules"
        ? "sidebar__link active"
        : "sidebar__link"
    }
    >
    <AiOutlineCalendar className="sidebar_icon" />
    Coach Schedules
  </div>
</Link>
        <Link className="alink" to="/lessons">
          <div
            className={
              location.pathname === "/lessons"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <AiOutlineCalendarAlt className="sidebar_icon" />
            Lessons
          </div>
        </Link>
        <Link className="alink" to="/upcoming-lessons">
          <div
            className={
              location.pathname === "/upcoming-lessons"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <AiOutlineClockCircle className="sidebar_icon" />
            Upcoming Lessons
          </div>
        </Link>
        <Link className="alink" to="/players">
          <div
            className={
              location.pathname === "/players"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <BsFillPersonFill className="sidebar_icon" />
            Players
          </div>
        </Link>
        <Link className="alink" to="/players/missing-email">
          <div
            className={
              location.pathname === "/players/missing-email"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <BsFillPersonFill className="sidebar_icon" />
            Missing Email
          </div>
        </Link>
        <Link className="alink" to="/marketing-segments">
          <div
            className={
              location.pathname === "/marketing-segments"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaBullhorn className="sidebar_icon" />
            Marketing Segments
          </div>
        </Link>
        <Link className="alink" to="/match-results">
          <div
            className={
              location.pathname === "/match-results"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaTrophy className="sidebar_icon" />
            Match Results
          </div>
        </Link>
        <Link className="alink" to="/match-needs">
          <div
            className={
              location.pathname === "/match-needs"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaTrophy className="sidebar_icon" />
            Match Needs
          </div>
        </Link>
        <Link className="alink" to="/leagues">
          <div
            className={
              location.pathname === "/leagues"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaTrophy className="sidebar_icon" />
            Leagues
          </div>
        </Link>
        <Link className="alink" to="/restringing-vendors">
          <div
            className={
              location.pathname === "/restringing-vendors"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaStore className="sidebar_icon" />
            Restringing Admin
          </div>
        </Link>
        <Link className="alink" to="/admin/demos">
          <div
            className={
              location.pathname === "/admin/demos"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaStore className="sidebar_icon" />
            Demo Loans
          </div>
        </Link>
        <Link className="alink" to="/admin/demo-assets">
          <div
            className={
              location.pathname === "/admin/demo-assets"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaStore className="sidebar_icon" />
            Demo Assets
          </div>
        </Link>
        <Link className="alink" to="/admin/demo-policies">
          <div
            className={
              location.pathname === "/admin/demo-policies"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaStore className="sidebar_icon" />
            Demo Policies
          </div>
        </Link>
        <Link className="alink" to="/coach-commissions">
          <div
            className={
              location.pathname === "/coach-commissions"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <RiMoneyEuroCircleFill className="sidebar_icon" />
            Coach commissions
          </div>
        </Link>
        <Link className="alink" to="/transaction">
          <div
            className={
              location.pathname === "/transaction"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <RiMoneyEuroCircleFill className="sidebar_icon" />
            Transactions
          </div>
        </Link>
        <Link className="alink" to="/credit-ledger">
          <div
            className={
              location.pathname === "/credit-ledger"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <RiMoneyEuroCircleFill className="sidebar_icon" />
            Credit Ledger
          </div>
        </Link>
        <Link className="alink" to="/credits-dashboard">
          <div
            className={
              location.pathname === "/credits-dashboard"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <RiMoneyEuroCircleFill className="sidebar_icon" />
            Credits Dashboard
          </div>
        </Link>
        <Link className="alink" to="/package-purchases">
          <div
            className={
              location.pathname === "/package-purchases"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <RiMoneyEuroCircleFill className="sidebar_icon" />
            Package Purchases
          </div>
        </Link>
        
        <Link className="alink" to="/locations">
          <div
            className={
              location.pathname === "/locations"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <HiLocationMarker className="sidebar_icon" />
            Locations
          </div>
        </Link>
        <Link className="alink" to="/locations_search">
          <div
            className={
              location.pathname === "/locations_search"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <HiLocationMarker className="sidebar_icon" />
            Locations Search
          </div>
        </Link>
        <Link className="alink" to="/player_locations">
          <div
            className={
              location.pathname === "/player_locations"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <HiLocationMarker className="sidebar_icon" />
            Player Locations Search
          </div>
        </Link>
        <Link className="alink" to="/shopify">
          <div
            className={
              location.pathname === "/shopify"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaShopify className="sidebar_icon" />
            Shopify orders
          </div>
        </Link>
        <Link className="alink" to="/question">
          <div
            className={
              location.pathname === "/question"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaQuestionCircle className="sidebar_icon" />
            Questions
          </div>
        </Link>
        <Link className="alink" to="/filters">
          <div
            className={
              location.pathname === "/filters"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaQuestionCircle className="sidebar_icon" />
            filters
          </div>
        </Link>
        <Link className="alink" to="/external_lesson_clicks">
          <div
            className={
              location.pathname === "/external_lesson_clicks"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaQuestionCircle className="sidebar_icon" />
            External lesson clicks
          </div>
        </Link>
        <Link className="alink" to="/external_lessons">
          <div
            className={
              location.pathname === "/external_lessons"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaQuestionCircle className="sidebar_icon" />
            External lessons
          </div>
        </Link>
        <Link className="alink" to="/messages">
          <div
            className={
              location.pathname === "/messages"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaQuestionCircle className="sidebar_icon" />
            messages
          </div>
        </Link>
        <Link className="alink" to="/survey_user_answers">
          <div
            className={
              location.pathname === "/survey_user_answers"
                ? "sidebar__link active"
                : "sidebar__link"
            }
          >
            <FaQuestionCircle className="sidebar_icon" />
            Survey User Answers
          </div>
        </Link>
        <Link className="alink" to="/coach-match-requests">
          <div className={location.pathname === "/coach-match-requests" ? "sidebar__link active" : "sidebar__link"}>
            <BsFillPersonFill className="sidebar_icon" />
            Coach Match Requests
          </div>
        </Link>
        <div
          className="sidebar__link error signout"
          onClick={() => {
            signout(() => {
              window.location.reload();
            });
          }}
        >
          <FaSignOutAlt className="error sidebar_icon" />
          Signout
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
